import React from 'react';
import '../style/PrivacyTerms.css';

const PrivacyPolicy= () => {
    return (
        <div className="static-page">
            <h1 className="align-center">מדיניות פרטיות</h1>
            <p className="align-center">תאריך עדכון אחרון 30.09.24</p>

            <h3>1. מבוא</h3>
            <p>
                1. ברוך הבא לשירותים הדיגיטליים של [Not Alone] (להלן "החברה" או "אנחנו")
                הכוללים את האפליקציה שלנו [שכתובתה www.not-alone.app] (להלן:
                "השירותים הדיגיטליים"). אנו מכבדים את הפרטיות של לקוחותינו המשתמשים
                בשירותים הדיגיטליים (להלן: "המשתמש(ים)" או "את/ה") ומחויבים להגן על המידע
                האישי שנאסף אודותיך. אנו מחויבים לגלות למשתמשים שלנו כיצד אנו אוספים
                ומשתמשים במידע המתקבל על ידינו בזמן השימוש בשירותים הדיגיטליים ולאחריו,
                וכן לפרט את מדיניות החברה ומחויבותה בהגנה על פרטיות המשתמשים.
            </p>
            <p>
                1.1. מטרתה של מדיניות הפרטיות המפורטת כדלהלן (להלן: "מדיניות הפרטיות") היא
                לכבד ולהגן על הפרטיות של המשתמשים ולהסביר מהם נוהגי החברה ביחס
                לפרטיות המשתמשים בשירותים הדיגיטליים וכיצד משתמשת החברה במידע הנמסר
                לה ע"י המשתמשים בשירותים הדיגיטליים או הנאסף על ידה בעת השימוש
                בשירותים הדיגיטליים.
            </p>
            <p>
                1.2. המסמך כתוב בלשון זכר מטעמי נוחות בלבד, אך מתייחס
                לשני המינים כאחד.
            </p>

            <h3>2. הסכמה</h3>
            <p>
                2.1. השימוש בשירותים הדיגיטליים ייחשב כהסכמה מצד המשתמש לכל התנאים,
                ההתניות וההודעות בקשר לשירותים הדיגיטליים. מסירת נתונים אישיים מצד
                המשתמש באמצעות השירותים הדיגיטליים של החברה מצביעה על הסכמתך לכך
                שהחברה תעשה שימוש בנתונים אלו בהתאם למדיניות פרטיות זו.
            </p>
            <p>
                2.2. בעת השימוש בשירותים הדיגיטליים נאסף עליך מידע, כמפורט להלן – לצורך קבלת
                השירותים ובמקרים מסוימים יהיה עליך לספק לנו מידע אישי הרלוונטי לשירות
                המבוקש. במסירת פרטים אלה, הנך מצהיר כי הפרטים האישיים שמסרת לחברה
                אמינים ומדויקים, כי הם נמסרים בהסכמתך ומרצונך החופשי וכי אתה מודע שלא
                קיימת חובה חוקית למסירת המידע, אלא אם צוין במפורש אחרת. חלק מהמידע אינו
                מזהה אותך אישית ואינו נשמר ביחד עם פרטיך.
            </p>
            <p>
                2.3. ויתור על טענות: בעצם שימושך באתר, הנך מאשר כי אין ולא יהיו לך טענות ו/או
                דרישות ו/או תביעות כלפי החברה או מי מטעמה בכל הקשור לפלטפורמה ו/או
                השירות שניתן באמצעותה, מגבלותיו, או אי התאמה ככל שתהיה.
            </p>

            <h3>3. שמירה ואיסוף מידע אישי</h3>
            <p>
                3.1. מידע שאתה מספק לנו: חלק מהשירותים הדיגיטליים שמציעה החברה מחייבים
                הזדהות של המשתמש באמצעות הזנת פרטים אישיים, כגון: שם מלא, תמונה
                ודוא"ל. תוכל גם להשתמש בשירותים הדיגיטליים ולהנות מתכניהם ללא הזנת
                פרטים אישיים, אך יודגש כי מסירת פרטי הזיהוי ופרטי הקשר, מהווה תנאי לקבלת
                השירותים המזוהים.
                משתמש שאינו מעוניין למסור את פרטי הזיהוי או את פרטי
                הקשר, או משתמש שפרטי הזיהוי שמסר לא תואמים למידע המופיע במאגרי המידע
                הרשמיים הרלוונטיים, לא יוכל לקבל את השירות המקוון, ועליו לפנות לחברה לשם
                קבלתו באמצעים אחרים.
            </p>
            <p>
                3.2. רישום לשירותים: ככל שנדרשים פרטים אישיים בעת רישום לשירותים הדיגיטליים,
                החברה תבקש ממך רק את המידע הנחוץ במישרין לאספקת השירותים.
            </p>
            <p>
                3.3. מידע שנאסף באופן אוטומטי: כאשר אתה עושה שימוש בשירותים הדיגיטליים, החברה אוספת מידע הנשלח אליה
                על ידי הטלפון הנייד או מכשיר אחר בו אתה משתמש לצורך גישה לשירותים. המידע
                הנשלח אלינו כולל, בין היתר (אך לא מוגבל): כתובת IP של המכשיר, מספר
                הזיהוי או מזהה ייחודי של המכשיר, סוג המכשיר, פרטי מיקום גיאוגרפי, פרטי
                מחשב וחיבור, פרטי רשת למכשירים ניידים, נתונים סטטיסטיים על צפיות בדפים,
                תעבורה אל האתר וממנה, כתובת URL להפניה, נתוני פרסומות וכן נתוני יומן
                אינטרנט ופרטים סטנדרטיים אחרים.
                נאסף גם מידע אנונימי באמצעות קובצי Cookies ומשוואות אינטרנט (ראה בהמשך תחת הכותרת "מדיניות עוגיות").
                המידע שנאסף הוא לצרכי סטטיסטיקה, קידום האתר ושיפור חווית השימוש באתר שלנו בלבד.
            </p>
            <p>
                3.4. יצירת קשר :באפשרותך לפנות אלינו במספר דרכים, בהן בין היתר, באמצעות טופס
                פניה בו יהיה עליך להזין פרטים אישיים כגון פרטי קשר ודוא&quot;ל. במסגרת פניה זו,
                אתה תבחר לפי שיקול דעתך איזה מידע תרצה לשתף איתנו בתוכן ההודעה ואיזה
                מידע לא לשתף. ככל שתמסור לנו יותר מידע רלוונטי, הסיוע שנוכל להעניק לך יהיה
                מדויק יותר.
            </p> 
            <p>
                3.5. לא נישא באחריות לכל נזק, מכל סוג שהוא, שייגרם לך או מי מטעמך במישרין ו/או
                בעקיפין עקב/בהקשר לגלישה באתר האינטרנט.
            </p>

            <h3>4. שימוש במידע</h3>
            <p>
                השימוש במידע המפורט לעיל יעשה בהתאם לכל דין, הסכם ומדיניות פרטיות זו, וזאת למטרות
                הבאות:
            </p>
            <p>
                1. לאפשר למשתמש לעשות שימוש בשירותים הדיגיטליים השונים;
            </p>
            <p>
                2. לצורך מתן השירותים על ידי החברה;
            </p>
            <p>
                3. לצורך עיבוד מידע סטטיסטי באמצעות איסוף וניתוח מידע אנונימי, סטטיסטי, או מצרפי (אגרגטיבי) אם על ידי החברה ואם על ידי מסירת מידע סטטיסטי לצדדים שלישיים; זאת על מנת לשפר ולהעשיר את השירותים והתכנים ואת חווית השימוש שלך בשירותים הדיגיטליים, ובכלל זה ליצור שירותים ותכנים חדשים המתאימים לדרישות המשתמשים וציפיותיהם וכן לשנות או לבטל שירותים ותכנים קיימים;
            </p>
            <p>
                4. בכדי לזהות, למנוע או לטפל בתרמית, בסוגיות אבטחת מידע או בבעיות טכניות;
            </p>
            <p>
                5. להגן בפני פגיעה בזכויות צדדים שלישיים, לרבות זכויות קניין רוחני, פגיעה בפרטיות ולשון הרע;
            </p>
            <p>
                6. לצורך קבלת פניות מהמשתמשים וטיפול בהן;
            </p>
            <p>
                7. דיוור ישיר וקשר עם המשתמשים בשירותים;
            </p>
            <p>
                8. לצורך אבטחת השירותים הדיגיטליים;
            </p>
            <p>
                9. לצורך מסירת מידע לצדדים שלישיים, כמפורט במדיניות זו;
            </p>
            <p>
                10. המידע אשר יימסר על-ידך יישמר במאגרי המידע של החברה ועשוי לשמש את החברה לצרכים תפעוליים ו/או לצורך ניתוחים סטטיסטיים.
            </p>

            <h3>5. מאגרי מידע</h3> 
            <p>
                5.1. הנתונים הנאספים יישמרו במאגרי המידע שלנו ובאחריותנו.
            </p>
            <p>
                5.2. שימוש במידע יבוצע בהתאם למטרות שהוגדרו, בהתאם למסמך זה ובכפוף להוראות כל דין ולחובות החלות על פי כל דין, לרבות דיני הגנת הפרטיות.
            </p>
            <p>
                5.3. מבלי לגרוע מכלליות האמור לעיל, אנו מתחייבים לקיים את הוראות הדין בכל הנוגע לשמירה והעברה של מידע אישי ונתונים של משתמשי השירותים הדיגיטליים, ומתחייבת לקיים את הוראות חוק הגנת הפרטיות, התשמ"א-1981 (להלן: "<b>חוק הגנת הפרטיות</b>") והתקנות שהותקנו מכוחו, לרבות תקנות הגנת הפרטיות (אבטחת מידע), התשע"ז-2017 ("<b>תקנות אבטחת מידע"</b>), הנחיות רשם מאגרי המידע הרלבנטיות, והכל כפי שיעודכנו מעת לעת.
            </p>

            <h3>6. העברת מידע לצד שלישי</h3>   
            <p>
                6.1. <u>לצורך מתן השירותים</u>: החברה עשויה להעביר את המידע האישי לחברות הקשורות אליה ו/או לצדדים שלישיים ובתנאי שהדבר יהיה נחוץ למטרות תפעוליות, לסליקת תשלומים על ידי המשתמשים, ניהול חשבונות המשתמשים, ליצירת קשר טוב יותר עם המשתמש, למטרות סטטיסטיות, לסקרי שביעות רצון וחווית משתמש, ולצרכי דיוור ישיר, לרבות משלוח הודעות טקסט והודעות דואר אלקטרוני בקשר עם שירותי החברה. כמו כן, יתכן שהחברה תעביר מידע אישי לצדדים שלישיים אשר משתפים פעולה עם החברה לשם ביצוע המטרות המנויות לעיל.
            </p>
            <p>
                6.2. לא נעביר מידע מזוהה אודות המשתמש לצדדים שלישיים אלא במקרים המפורטים להלן:
            </p>
            <div className='small-padding'>
                <p>
                    6.2.1. על פי דרישת המשתמש ו/או בהסכמתו המפורשת.
                </p>
                <p>
                    6.2.2. בכל מקרה בו הפר המשתמש את תנאי השימוש ו/או מדיניות הפרטיות ו/או במקרים בהם ביצע המשתמש או ניסה לבצע המשתמש ו/או מי מטעמו, באמצעות האתר ו/או בקשר אתו, פעולות המנוגדות להוראות תנאי תנאי השימוש ו/או מדיניות הפרטיות, ו/או להוראות כל דין.
                </p>
                <p>
                    6.2.3. בשל צו שיפוטי המורה לחברה למסור את המידע לצדדים שלישיים.
                </p>
                <p>
                    6.2.4. בשל כל מחלוקת, טענה, תביעה, דרישה ו/או הליכים משפטיים אשר יתנהלו בין המשתמש ו/או מי מטעמו לבין החברה ו/או מי מטעמה.
                </p>
                <p>
                    6.2.5. בכל מקרה בו תסבור החברה, כי מסירת המידע נחוצה על מנת למנוע או להקטין נזק לרכוש ו/או נזק גוף, בין של החברה, המשתמש ו/או של צדדים שלישיים ו/או על מנת למנוע נזק חמור אחר, וזאת לפי שיקול דעתה הבלעדי של החברה.
                </p>
                <p>
                    6.2.6. במקרה בו העבירה ו/או המחתה החברה לצד שלישי את פעילותה ו/או את זכויותיה וחובותיה כלפי המשתמש, ובלבד שצדדים שלישיים כאמור יקבלו על עצמם את ההוראות המפורטות במדיניות פרטיות זו.
                </p>
                <p>
                    6.2.7. עם גופים בפועלים בשמנו וכן עם נותני שירותים צדדים שלישיים המסייעים לנו במתן השירותים וייעולם לרבות קבלני-משנה, ספקי מיקור חוץ כגון Google נותני שירותי Cookies, וספקים חיצוניים אחרים לצורך סליקה, אחסון, גבייה, שירותי מחשוב ענן, ספקי תקשורת, תחזוקה, בתי דפוס, גופי ביקורת וכיו"ב, בכפוף להסכמי התקשרות, ותוך שימוש בכל האמצעים הנדרשים לשמירה על סודיות ואבטחה.
                </p>
                <p>
                    6.2.8. מידע אנונימי – החברה עשויה לשתף מידע אנונימי סטטיסטי, שאינו מאפשר זיהוי אישי עם כלל הציבור כגון מפתחים או בעלי זכויות, לצרכי מחקר ו/או סטטיסטיקה ו/או שיפור השירותים וכיו"ב.
                </p>
            </div>
            <h3>7. אבטחת מידע</h3>
            <p>
                7.1 החברה נוקטת באמצעים רבים ברמה הארגונית, התשתיתית והיישומית על מנת
                להגן על המידע האישי שלך, לרבות יישום של מנגנוני הגנה מתקדמים כדי לאבטח
                את המידע באתר. עם זאת, כבכל מאגר מידע ממוחשב, החברה אינה יכולה להבטיח
                חסינות מוחלטת מפני חדירות למחשביה, ניסיונות לחדירות כאלו, חשיפת מידע או
                שיבושים והפרעות לפעילות מערכות המחשב המשמשות את השירותים הדיגיטליים.
                על כן, אם יש לך חששות בנוגע למידע מסוים, הימנע מלהעביר אותו באמצעות
                האינטרנט.
            </p>
            <p>
                7.2. הנך מתחייב כי לא תבצע כל פעולה המיועדת לחדור שלא כדין למחשבי החברה,
                לסרוק אחר נתיבי גישה או פרצות במערכות מחשב אלה, לפצח את מערכות
                האבטחה או ההצפנה המגנות על השירותים הדיגיטליים ו/או על המידע שבהם או
                לסייע בפעולות כאמור לעיל.
            </p>
            <h3>8. הסכמה בדבר קבלת דבר פרסומת ודיוור ישיר</h3>
            <p>
                8.1. אנו מבצעים דיוורים באמצעות דוא"ל, הודעות טקסט או אמצעים אלקטרוניים ואחרים בהתאם להוראות סעיף 30א לחוק התקשורת (בזק ושידורים) התשמ"ב-1982. במסגרת הדיוורים כאמור אנו עשויים לפנות אליך בדיוור ישיר על בסיס השתייכותך לקבוצה בעלת מאפיינים מסוימים ועל בסיס פעולות פילוח ואפיון שאנו עורכים על בסיס המידע שנשמר אצלנו כאמור לעיל בהתאם להוראות חוק הגנת הפרטיות, התשמ"א-1981. תכני הדיוור עשויים לכלול דברי פרסומת, עדכונים שונים ותכנים נוספים לפי בחירתנו.
            </p>
            <p>
                8.2. לעולם לא נמכור או נעביר את פרטייך האישיים לצד שלישי כלשהו לצרכיו השיווקיים ללא הסכמתך המפורשת.
            </p>
            <p>
                8.3. אתה רשאי בכל עת לבטל דיוור זה, להיגרע ממאגר הדיוור או להסיר עצמך מרשימת תפוצה כזו או אחרת, <b>באמצעות שליחת בקשה למייל</b> 
            </p>
            <h3>9. אתרים אחרים</h3>
            <p>
                9.1. השירותים הדיגיטליים עשויים להכיל קישורים לאתרים או משאבי אינטרנט אחרים. כאשר תקליק על אחד מקישורים אלה תתחבר לאתר או משאב אינטרנט אחר, אשר עלול לאסוף מידע אודותיך מרצונך או באמצעות עוגיות או טכנולוגיות אחרות. 
            </p>
            <p>
                9.2. מדיניות הפרטיות שלנו אינה חלה על מוצרים או שירותים שמציעים צדדים שלישיים, לרבות מוצרים או אתרים העשויים להופיע בתוצאות החיפוש שלך או אתרים שהקישורים אליהם מופיעים באתרי החברה, אתרים העשויים לכלול את שירותינו או אתרים אחרים עם קישור מהאתרים או מהשירותים שלנו.
            </p>
            <p>
                9.3. כל שימוש בתוכן של צד שלישי, לרבות כל כניסה של המשתמש לאתרים של צדדים שלישיים על-ידי הפניה בשירותים הדיגיטליים, יתבצע על אחריותך הבלעדית ולא תהיה כל טענה ו/או תביעה כנגד החברה בקשר לכך, לרבות אך מבלי לגרוע, בגין כל נזק, ישיר או עקיף, הנובע משימוש ו/או כניסה כאמור ו/או בשל פגיעה בפרטיות ו/או כל איסוף מידע ו/או שימוש בו על ידי צדדים שלישיים. אנו ממליצים לך לקרוא את מדיניות הפרטיות ותנאי השימוש של אותם צדדים שלישיים לפני כניסה לכל אתר אחר כאמור. 
            </p>
            <h3>10. זכות העיון והתיקון</h3>
            <p>
                10.1. הנך זכאי לעיין במידע המוחזק אודותיך במאגרי המידע של החברה, בעצמך או
                באמצעות בא כוחך שהורשה בכתב או על ידי אפוטרופוס. לצורך כך, הנך מוזמן
                לפנות אלינו בכתובת <a href='mailto:contact@not-alone.app'>contact@not-alone.app</a> אנחנו נשיב לך על בקשתך
                בהקדם האפשרי ונאפשר לעיין במידע אודותייך לא יאוחר מ-30 יום מיום הגשת
                הבקשה.
            </p>
            <p>
                10.2. הנך זכאי, לאחר שעיינת במידע אודותיך ומצאת כי הוא אינו נכון, שלם, ברור או
                מעודכן, לבקש לתקן או למחוק את המידע אודותייך. לצורך כך, הנך מוזמן לפנות
                אלינו בכתובת <a href='mailto:contact@not-alone.app'>contact@not-alone.app</a> אנחנו נשיב לך על בקשתך בהקדם
                האפשרי ולא יאוחר מ-30 יום מיום הגשת הבקשה.
            </p>
            <h3>11. מדיניות עוגיות - COOKIE POLICY</h3>
            <p>
                11.1. כמו אתרים רבים, החברה משתמשת ב"עוגיות"/קוקיות, pixels, web beacons
                או טכנולוגיות דומות (ביחד להלן: "Cookies") לצורך אחסון מידע באופן מקומי על מכשירך ושיפור חווית הגלישה והשימוש בשירותים הדיגיטליים.
                Cookie הוא קובץ מידע קטן שנשמר על המכשיר שלך לצורך תיעוד אופן השימוש שלך באתר או באפליקציה.
                בעת כניסתך לאתרי האינטרנט של החברה, אנחנו עשויים למקם קבצים אלה במחשב או במכשיר שלך.
            </p>
            <p>
                11.2. אנו עשויים להשתמש בטכנולוגיה זו לצורך תפעול שוטף ותקין של השירותים
                הדיגיטליים, ובכלל זה כדי לאסוף נתונים סטטיסטיים אודות השימוש באפליקציה,
                לצורך אימות פרטים, כדי להתאים אישית שירותים להעדפותיך האישיות, להציג
                תוכן ופרסומות, למדוד את האפקטיביות של פעולות לשיפור השירות, למזער
                סיכונים ולמנוע הונאות. כאשר תבקר שוב באתר, קובץ Cookie יאפשר לאתר
                לזהות את הדפדפן שלך.
            </p>
            <p>
                11.3. בנוסף אנו עשויים להשתמש בטכנולוגיה זו כדי לאסוף מידע אודות הדפים שבהם
                ביקרת, משך הזמן ששהית באתר/באפליקציה, מאיזה אתר הגעת, כתובת ה-IP
                שלך, מאפייני המכשיר שלך, מידע שתבקש לראות בעת הכניסה לאתר ועוד. כמו
                כן, ייתכן שהעוגיות ישמרו מידע אודות הרגלי הגלישה שלך באתרים אחרים,
                לרבות אתרים ואפליקציות בהם גלשת, ופעולות אחרות שביצעת בהם. השימוש
                בטכנולוגיה זו אין בו כדי להצביע על זהותו של אדם, אלא אם מדובר במשתמש
                רשום.
            </p>
            <p>
                11.4. תמיד עומדת בפנייך האפשרות לחסום ו/או למחוק Cookies בכל עת באופן
                עצמאי על ידי שינוי ההגדרות במכשירך ו/או בדפדפנים בהם אתה עושה שימוש.
                ידוע לך כי ייתכן שחלק מהשירותים לא יהיו נגישים ו/או חוויית השימוש לך
                בשירותים תהא מוגבלת במידה ותחסום ו/או תמחק את ה- Cookies. למידע נוסף
                ראה: www.allaboutcookies.org
            </p>
            <p>
                11.5. אנו משתמשים, בין היתר, ב-Cookies של צדדים שלישיים כדוגמת: Reblaze,
                Glassbox, Google Analytics Application Insights, . מידע זה אינו כולל
                פרטים אישיים, למעט מזהה מכשיר, כתובת IP ו- Advertising ID אשר עשויים
                להיאסף.
            </p>
            <p>
                11.6. גוגל אנליטיקס – משתמשים בקבצי &quot;Cookies&quot; במטרה לסייע לאתר לנתח כיצד
                המבקרים משתמשים באתר. האינפורמציה שנאספת בסיוע קובץ ה-&quot;Cookie&quot;
                מועברת ונשמרת בשרתי גוגל. גוגל משתמשת במידע זה כדי להעריך את השימוש
                שלך באתר ולערוך דוחות על פעילות האתר ועל השימוש באינטרנט בשביל מנהלי
                אתרים. גוגל עשויה גם להעביר את המידע לצד שלישי, כאשר היא נדרשת לכך
                מתוקף חוק, או כאשר צד שלישי מעבד את המידע בשביל גוגל. גוגל לא תשייך את
                כתובת ה-IP עם מידע אחר שיש לגוגל. למידע נוסף על אופן ביטול שליחת מידע
                ל- Google Analytics לחצו <a href='https://chromewebstore.google.com/detail/google-analytics-opt-out/fllaojicojecljbmefodhfapmkghcbnh?hl=en-GB&pli=1'>כאן</a>. 
                להרחבה בנושא Google Analytics לחצו <a href='https://policies.google.com/technologies/cookies'>כאן</a>.
                גלישה באתר זה מהווה את הסכמתכם לאיסוף המידע על ידי גוגל באופן ולמען
                השימושים שצוינו לעיל.
            </p>
            <h3>12. עדכון מדיניות הפרטיות</h3>
            <p>
                החברה שומרת על זכותה לשנות ו/או להתאים את הוראות מדיניות הפרטיות מעת לעת ובהתאם
                לצורך, על פי שיקול דעתה הבלעדי וללא התחייבות למתן הודעה, מוקדמת ו/או בדיעבד. במקרה של
                עדכון במדיניות הפרטיות, החברה תעדכן את &quot;תאריך העדכון&quot; בראש המסמך והשינויים ייכנסו
                לתוקף מיד עם הצגת מדיניות הפרטיות המעודכנת בשירותים הדיגיטליים. באחריותך לבדוק את
                מדיניות הפרטיות ותאריך העדכון שלה מעת לעת.
            </p>
            <h3>13. צור קשר</h3>
            <p>
                הנך מוזמן ליצור אתנו קשר בכל שאלה או בעיה הקשורה בשירותים הדיגיטליים ו/או במדיניות
                הפרטיות, בטופס המקוון בכתובת <a href='mailto:contact@not-alone.app'>contact@not-alone.app</a>.
            </p> 
        </div>
    );
};

export default PrivacyPolicy;